import React,{useState,useEffect} from 'react'
import Footer from '../inc/Footer'
import { Link,useNavigate } from 'react-router-dom'
import axios from 'axios';
import '../inc/GlobalVars';
import Loader from '../inc/Loader';
import { ToastContainer, toast } from 'react-toastify';
function UserProfile() {
    const[loading,setLoading] = useState(false);
    const user_id = localStorage.getItem('userId');
useEffect(()=>{
    getUserProfileData();
},[]);    
    const [inputData,setInputData] = useState([]);
    const [aadhaar,setAadhaar] = useState("");
    const [pan,setPan] = useState("");


async function getUserProfileData()
{
    setLoading(true);
    try {
await axios.get(global.apiUrl + "/getUserProfile/"+user_id).then(function (response) {
    const proData = response.data["data"][0];
    setInputData(proData);
    setLoading(false);
    const mynumber = proData['aadhaar_number'];

  // Extract the last four digits
  const lastFourDigits = mynumber.slice(-4);

  // Replace all characters except the last four with '*'
  const hiddenPart = '*'.repeat(mynumber.length - 4);

  // Concatenate the hidden part with the last four digits
  setAadhaar(hiddenPart + lastFourDigits);

  const myPan = proData['pan_number'];

  // Extract the last four digits
  const lastOneDigit = myPan.slice(-1);

  // Replace all characters except the last four with '*'
  const hiddenPart2 = '*'.repeat(myPan.length - 1);

  // Concatenate the hidden part with the last four digits
  setPan(hiddenPart2 + lastOneDigit);
})
    }
    catch (err) {
        console.log(err);
    }
    

}




  return (
    
    <div>
        <ToastContainer
position="top-left"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="colored"
/>
        {loading ? ( <Loader /> ) : (
<>

      <div className="container mb-5">
          <div className="row">
            <div className="col-md-12 mb-5  pt-5">
              <h1 style={{textTransform:"capitalize"}}>Profile</h1>
            </div>
          </div>

          <div className='row'>
            <form method='POST' encType='multipart/form-data'>
            <div className='row mb-2'>
                
                        <div className='col-md-6 mb-2'>
                            <label>Name<span className='text-danger'>*</span></label>
                            <input type='text' name="name" value={inputData['name']}  className='form-control' placeholder='Enter Your First Name' required disabled />
                        </div>
                        <div className='col-md-6 mb-2'>
                        <label>Email ID<span className='text-danger'>*</span></label>
                            <input type='email' name="email" value={inputData['email']} disabled className='form-control' placeholder='Enter Your Email ID' required />
                        </div>
                        </div>
                        
                        <div className='row mb-2'>
                        <div className='col-md-6 mb-2'>
                            <label>Phone Number<span className='text-danger'>*</span></label>
                            <input type='text' name="mobile" value={inputData['mobile']} disabled className='form-control' placeholder='Enter Phone Number' required />
                        </div>
                        <div className='col-md-6 mb-2'>
                            <label>Alternate Number<span className='text-danger'>*</span></label>
                            <input type='text' name="alternate_mobile" value={inputData['alternate_mobile']}  disabled className='form-control' placeholder='Enter Alternate Number' required />
                        </div>
                        </div>
                        <div className='row mb-2'>
                        <div className='col-md-12 mb-2'>
                            <label>Address<span className='text-danger'>*</span></label>
                            <input type='text' name="address" value={inputData['address']}   className='form-control' disabled placeholder='Enter Address' required />
                        </div>
                        
                        
                       
                        </div>

                        <div className='row mb-2'>
                        <div className='col-md-4 mb-2'>
                            <label>City<span className='text-danger'>*</span></label>
                            <input type='text' name="city" value={inputData['city']}  className='form-control' disabled placeholder='Enter City' required />
                        </div>
                        
                       
                        <div className='col-md-4 mb-2'>
                            <label>State<span className='text-danger'>*</span></label>
                            <input type='text' name="state" value={inputData['state_id']}  disabled className='form-control' placeholder='Enter State' required />
                        </div>
                        
                        <div className='col-md-4 mb-2'>
                            <label>Pincode<span className='text-danger'>*</span></label>
                            <input type='text' name="pincode" value={inputData['pincode']}  disabled className='form-control' placeholder='Enter Pincode' required />
                        </div>
                       
                        </div>

                        <div className='row mb-2'>
                        <div className='col-md-5 mb-2'>
                            <label>Aadhaar Number<span className='text-danger'>*</span></label>
                            <input type='text' name="aadhaar_number" value={aadhaar}  className='form-control' disabled placeholder='Aadhaar Number' required />
                        </div>
                        <div className='col-md-5 mb-2'>
                            <label>Pan Number<span className='text-danger'>*</span></label>
                            <input type='text' name="pan_number" value={pan}  className='form-control' disabled placeholder='Pan Number' required />
                        </div>
                        <div className='col-md-2 mb-2'>
                            <label>Security Deposit<span className='text-danger'>*</span></label>
                            <input type='text' name="security_deposit" value={inputData['security_deposit']}  className='form-control' disabled placeholder='Security Deposit' required />
                        </div>
                        </div>

                        

            </form>
          </div>
        </div>
      
     
        <Footer />

        
</> )}</div> );
}

export default UserProfile